// @flow
import type { AdditionalServicesInput } from "../types/checkFlightsApiTypes"

// Only identity function for now
const mapperAdditionalServices = (x?: AdditionalServicesInput) => x

export default mapperAdditionalServices
